import { apiGrupoEscanearQr, apiGrupoRechazarEntrada, apiGrupoSalidaEscuela } from "../API";
import { _APP_DATA } from "../AppData";
import { IApiResult, IResultQR } from "../models/Entities";
import { RequestData } from "../utils/RequestData";


export function _SvGrupoSalidaEscuela(childId: number, callback?: (status: number) => void): void {
    let params = {
        IdAlumno: childId,
        IdUsuario: _APP_DATA.userData.IdUsuario
    };

    new RequestData<IApiResult<any>>(apiGrupoSalidaEscuela)
        .Params(params)
        .Completion((response, error) => {
            let status = response ? response.Resultado : -111;
            if (error)
                console.log(error.name, error.message);

            if (callback) callback(status);
        }).Post();
}

export function _SvGrupoRechazarEntrada(childId: number, grupoId: number, callback?: (status: number) => void): void {
    let params = {
        IdAlumno: childId,
        IdUsuario: _APP_DATA.userData.IdUsuario,
        IdGrupo: grupoId || _APP_DATA.userData.IdGrupo
    };

    new RequestData<IApiResult<any>>(apiGrupoRechazarEntrada)
        .Params(params)
        .Completion((response, error) => {
            let status = response ? response.Resultado : -111;
            if (error)
                console.log(error.name, error.message);

            if (callback) callback(status);
        }).Post();
}

export function _SvGrupoEscanearQr(qrValue: string, callback?: (result: IResultQR) => void): void {
    let params = {
        IdEscuela: _APP_DATA.userData.IdKinder,
        IdUsuario: _APP_DATA.userData.IdUsuario,
        TxtQr: qrValue
    };

    new RequestData<IResultQR>(apiGrupoEscanearQr)
        .Params(params)
        .Completion((response, error) => {
            const result = response || { Resultado: -111, IdCategoria: -1, Descripcion: "", IdGrupo: -1, Accion: -1, IdAlumno: -1, InfoAlumno: null };
            if (error)
                console.log(error.name, error.message);

            if (callback) callback(result);
        }).Post();
}
